(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-header"]) return;
  try {
    
(() => {
  const menu = document.getElementById('mm-mobile-menu');
  const header = document.querySelector('.mm-header');
  if (!menu || !header) return;

  const openBtn = header.querySelector('[data-mm-menu-open]');

  const setOpenState = (open) => {
    document.documentElement.classList.toggle('mm-menu-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
  };

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      menu.showModal();
      setOpenState(true);
    });
  }

  menu.addEventListener('close', () => setOpenState(false));

  menu.querySelectorAll('[data-mm-menu-close], [data-mm-menu-link]').forEach((el) => {
    el.addEventListener('click', () => {
      menu.close();
    });
  });

  const bubble = document.getElementById('cart-icon-bubble');
  if (bubble) {
    const syncCounts = () => {
      const countEl = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
      const count = countEl ? countEl.textContent.trim() : '';
      document.querySelectorAll('[data-mm-cart-count]').forEach((el) => {
        if (count) {
          el.textContent = '· ' + count;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    };
    new MutationObserver(syncCounts).observe(bubble, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const video = document.querySelector('[data-mm-hero-video]');
  if (!video) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reduced || saveData) {
    video.remove();
    return;
  }

  let inView = false;

  const setPlayback = (visible) => {
    if (visible && document.visibilityState === 'visible') {
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {});
    } else {
      video.pause();
    }
  };

  video.addEventListener('canplay', () => video.classList.add('is-ready'));

  const observer = new IntersectionObserver(
    (entries) => {
      inView = entries[0].isIntersecting;
      setPlayback(inView);
    },
    { threshold: 0.08 }
  );
  observer.observe(video);

  document.addEventListener('visibilitychange', () => setPlayback(inView));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-main-product"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-mm-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('input');
    const max = Number(stepper.dataset.max) || 1;
    const msg = stepper.parentElement.querySelector('[data-mm-max-msg]');
    const sync = () => {
      let v = parseInt(input.value, 10);
      if (!Number.isFinite(v) || v < 1) v = 1;
      if (v > max) v = max;
      input.value = String(v);
      stepper.querySelector('[data-mm-step="-1"]').disabled = v <= 1;
      stepper.querySelector('[data-mm-step="1"]').disabled = v >= max;
      if (msg) msg.hidden = v < max;
    };
    stepper.querySelectorAll('[data-mm-step]').forEach((btn) =>
      btn.addEventListener('click', () => {
        input.value = String((parseInt(input.value, 10) || 1) + Number(btn.dataset.mmStep));
        sync();
      })
    );
    input.addEventListener('change', sync);
    sync();
  });

  const main = document.getElementById('mm-pdp-main');
  if (!main) return;
  document.querySelectorAll('[data-mm-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const full = btn.dataset.full;
      if (!full) return;
      main.src = full;
      main.removeAttribute('srcset');
      document.querySelectorAll('[data-mm-thumb]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sticky = document.querySelector('[data-mm-sticky]');
  if (!sticky) return;
  sticky.hidden = false;

  let pastHero = false;
  let blocked = false;

  const apply = () => {
    sticky.classList.toggle('is-visible', pastHero && !blocked);
  };

  const hero = document.getElementById('hero');
  if (hero) {
    new IntersectionObserver(
      (entries) => {
        pastHero = !entries[0].isIntersecting;
        apply();
      },
      { threshold: 0.08 }
    ).observe(hero);
  } else {
    pastHero = true;
  }

  const blockers = ['commander', 'footer']
    .map((id) => document.getElementById(id))
    .filter(Boolean);
  if (blockers.length) {
    const states = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => states.set(entry.target, entry.isIntersecting));
        blocked = Array.from(states.values()).some(Boolean);
        apply();
      },
      { threshold: 0.02 }
    );
    blockers.forEach((el) => observer.observe(el));
  }

  const bubble = document.getElementById('cart-icon-bubble');
  const syncItems = () => {
    const countEl = bubble && bubble.querySelector('.cart-count-bubble span[aria-hidden]');
    const count = countEl ? countEl.textContent.trim() : '';
    if (count) {
      sticky.setAttribute('data-has-items', '');
    } else {
      sticky.removeAttribute('data-has-items');
    }
  };
  if (bubble) {
    syncItems();
    new MutationObserver(syncItems).observe(bubble, { childList: true, subtree: true });
  }

  apply();
})();

  } catch(e) { console.error(e); }
})();
})();
